import PropTypes from 'prop-types';
import React from 'react';

import Linkifier from './lib/linkifier';
import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/EndMessage.css';

export default function EndMessage(props) {
  const endMessagePropTypes = {
    message: PropTypes.string,
  };
  PropTypes.checkPropTypes(endMessagePropTypes, props, 'prop', 'EndMessage');

  return (
    <EndMessageDiv data-aid="gladlyChatEndMessage">
      <Linkifier className={styles.endMessage} linkClassName={styles.endMessage_linkify}>
        {props.message}
      </Linkifier>
    </EndMessageDiv>
  );
}

const EndMessageDiv = overrideStyle('div')`
  align-self: center;
  color: #111111;
  font-family: ${p => p.theme.fontLibrary.primary};
  font-size: 14px;
  line-height: 19px;
  margin: 16px 12px 16px 12px;
  text-align: center;
  word-wrap: break-word;
`;
